import router from '@/router';

/********活动列表*******/
const activtyStatusList: any = [
  { activtyId: '', categoryName: '全部' },
  { activtyId: '0', categoryName: '待配置' },
  { activtyId: '1', categoryName: '进行中' },
  { activtyId: '2', categoryName: '暂停' },
  { activtyId: '3', categoryName: '已结束' },
  { activtyId: '4', categoryName: '待启动' },
  { activtyId: '5', categoryName: '已废弃' },
  // { activtyId: '6', categoryName: '待审核' }
]

const activtyStatus: any = {
  '': '全部',
  '0': '待配置',
  '1': '进行中',
  '2': '暂停',
  '3': '已结束',
  '4': '待启动',
  '5': '已废弃',
  // '6': '待审核'
};

export default {
  state: {
    activityList: [],//活动列表
    activtyStatusList,//活动状态列表
    launchCouponList: [],//已投放的券列表
    activityDetail: {},
    pageInfo: {//分页信息
      total: 0,
      pageNum: 1,
      pageSize: 10,
    }
  },
  getters: {
    getterActivityManagementlList(state: any) {
      // console.log(state);
      // const _list = state.activityList.map((item: any) => {
      //     let _item = item;
      //     _item.activityStartDate = router.app.$format(_item.activityStartDate, 'YYYY.MM.DD');
      //     _item.activityEndDate = router.app.$format(_item.activityEndDate, 'YYYY.MM.DD');
      //     _item.activityStatus = activtyStatus[`${item.activityStatus}`];
      //     return _item
      // });
      // return _list;
    },
    // getterLaunchCouponList(state: any) {
    //     console.log(state);
    //     const _list = state.launchCouponList.map((item: any) => {
    //         let _item = item;
    //         _item.couponGetStartTime = router.app.$format(_item.couponGetStartTime, 'YYYY.MM.DD');
    //         _item.couponGetEndTime = router.app.$format(_item.couponGetEndTime, 'YYYY.MM.DD');
    //         _item.activityStatus = activtyStatus[`${item.activityStatus}`];
    //         return _item
    //     });
    //     return _list;
    // }
  },
  mutations: {
    setactivityListPageLoading(state: any, status: boolean) {
      if (status) {
        state.launchCouponListPageLoading = true;
      } else {
        state.launchCouponListPageLoading = false;
      }
    },
    setlaunchCouponListPageLoading(state: any, status: boolean) {
      if (status) {
        state.activityListPageLoading = true;
      } else {
        state.activityListPageLoading = false;
      }
    },
    setActivityManagementlList(state: any, { list, total, pageNum, pageSize, status }: any) {
      const _list = list.map((item: any) => {
        let _item = item;
        _item.activityStartDate = router.app.$format(_item.activityStartDate, 'YYYY.MM.DD');
        _item.activityEndDate = router.app.$format(_item.activityEndDate, 'YYYY.MM.DD');
        _item.activityStatus = activtyStatus[`${item.activityStatus}`];
        return _item
      });
      if (status) {
        state.activityList = _list
      } else {
        // state.activityList = [...state.activityList, ..._list];
      }
      state.activityListPage = {//设置当前请求的分页
        total,
        pageNum,
        pageSize,
      };
    },
    setActivityDetail(state: any, params: any) {
      params.activityStartDate = router.app.$format(params.activityStartDate, 'YYYY.MM.DD');
      params.activityEndDate = router.app.$format(params.activityEndDate, 'YYYY.MM.DD');
      params.activityStatus = activtyStatus[`${params.activityStatus}`];
      state.activityDetail = params;
    },
    // setLaunchCouponList(state: any, { list, total, pageNum, pageSize }: any) {

    //     state.launchCouponPage = {//设置当前请求的分页
    //         total,
    //         pageNum,
    //         pageSize,
    //     };
    //     state.launchCouponList = [...state.launchCouponList, ...list];
    // }
  },
  actions: {
    async getActivityList({ commit, state }: any, params: any) {
      const status = params.status;
      delete params.status;
      params.upTenantId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId;
      params.upTenantType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType;
      const { error, success }: any = await router.app.$request('ACTIVITY_MANAGEMENT_LIST', params);
      // if (success) {
      //     commit('setActivityManagementlList', { ...success.data, status });
      // }
      return { error, success };
    },
    async getActivityDetail({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('ACTIVITY_MANAGEMENT_DETAIL', params);
      if (success) {
        commit('setActivityDetail', { ...success.data });
      }
      return { error, success };
    },
    async getLaunchCouponList({ commit }: any, params: any) {
      // commit('setlaunchCouponListPageLoading', true);
      params.businessEntityId = router.app.$global.tenantId;
      const { error, success }: any = await router.app.$request('LAUNCH_COUPON_LIST', params);
      if (success) {
        // commit('setLaunchCouponList', { ...success.data });
        // commit('setlaunchCouponListPageLoading', false);
      }
      return { error, success };
    },
  }
}